export const CREATE_ROOMS_REQUEST = "CREATE_ROOMS_REQUEST";
export const CREATE_ROOMS_SUCCESS = "CREATE_ROOMS_SUCCESS";
export const CREATE_ROOMS_FAIL = "CREATE_ROOMS_FAIL";
export const CREATE_ROOMS_CLEAR = "CREATE_ROOMS_CLEAR";

export const DELETE_ROOMS_REQUEST = "DELETE_ROOMS_REQUEST";
export const DELETE_ROOMS_SUCCESS = "DELETE_ROOMS_SUCCESS";
export const DELETE_ROOMS_FAIL = "DELETE_ROOMS_FAIL";
export const DELETE_ROOMS_CLEAR = "DELETE_ROOMS_CLEAR";

export const GET_ALL_ROOM_REQUEST = "GET_ALL_ROOM_REQUEST";
export const GET_ALL_ROOM_SUCCESS = "GET_ALL_ROOM_SUCCESS";
export const GET_ALL_ROOM_FAIL = "GET_ALL_ROOM_FAIL";

export const GET_SINGLE_ROOM_REQUEST = "GET_SINGLE_ROOM_REQUEST";
export const GET_SINGLE_ROOM_SUCCESS = "GET_SINGLE_ROOM_SUCCESS";
export const GET_SINGLE_ROOM_FAIL = "GET_SINGLE_ROOM_FAIL";

export const UPDATE_ROOMS_REQUEST = "UPDATE_ROOMS_REQUEST";
export const UPDATE_ROOMS_SUCCESS = "UPDATE_ROOMS_SUCCESS";
export const UPDATE_ROOMS_FAIL = "UPDATE_ROOMS_FAIL";
export const UPDATE_ROOMS_CLEAR = "UPDATE_ROOMS_CLEAR";
